type VersionPayload = {
  version: string
}

export const getAppVersion = async (): Promise<string> => {
  const response = await fetch(`${import.meta.env.BASE_URL}version.json`, { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`Failed to load version.json (${response.status})`)
  }
  const payload: VersionPayload = await response.json()
  return payload.version
}
